<template>
  <div class="bb b--black-10">
    <ul class="list pt4 pl5 nav nav-tabs">
      <li class="ma0 pa0 mr4 f3 fw6 dib" :class="{ active: projectsShowing }">
        <a href="#pro-profile-projects" class="near-black hover-silver pb3 dib bb b--black" @click.prevent="showProjects" role="tab">My Posts</a>
      </li>
      <li class="ma0 pa0 mr4 f3 fw6 dib" :class="{ active: collaborationsShowing }" >
        <a href="#pro-profile-collaborations" class="near-black hover-silver pb3 dib" @click.prevent="showCollaborations" role="tab">Collaborations</a>
      </li>
    </ul>
    <div class="tab-content pa4">
      <div v-if="projectsShowing" id="pro-profile-projects">
        <pro-profile-projects :pro-user-id="proUserId" />
      </div>
      <div v-if="collaborationsShowing" id="pro-profile-collaborations">
        <pro-profile-collaborations :pro-user-id="proUserId" />
      </div>
    </div>
  </div>
</template>

<script>

import proProfileProjects from './ProProfileProjects'
import proProfileCollaborations from './ProProfileCollaborations'
import { mapState } from 'vuex'

export default {
    name: 'ProProfileTabs',

    components: {
        proProfileProjects: proProfileProjects,
        proProfileCollaborations: proProfileCollaborations,
    },

    props: {
        proUserId: {
            type: String,
            required: true,
        },
        projectId: {
            type: String,
            required: false,
        }
    },

    data() {
        return {
            projectsShowing: true,
            collaborationsShowing: false,
        }
    },

    computed: {
        ...mapState(['currentUser', 'env']),
    },

    methods: {
        showProjects(){
            this.collaborationsShowing = false;
            this.projectsShowing = true;
            // this.$redrawVueMasonry(); //????
        },

        showCollaborations(){
            this.collaborationsShowing = true;
            this.projectsShowing = false;
            // this.$redrawVueMasonry(); //????
        }
    }
}
</script>

<style scoped>

.nav-tabs li a {
    background: transparent;
    border: none;
    font-weight: normal;
}

.nav-tabs li a:hover {
    color: #333;
}

.nav-tabs li.active>a {
    font-weight: bold;
}

.nav-tabs>li.active>a, 
.nav-tabs>li.active>a:focus, 
.nav-tabs>li.active>a:hover {
    border-bottom: 1px solid #333;
    border-left: none;
    border-right: none;
    border-top: none;
    background: transparent !important;
    cursor: pointer;
    color: #333;
}

.nav-tabs>li.active>a:hover {
    background-color: white !important;
}

</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/profile/components/ProProfileTabs.vue